import type { HTMLAttributes, PropsWithChildren } from "react";

import { cn } from "@/lib/utils";

export function Card({ className, children, ...rest }: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
  return (
    <div
      className={cn("rounded-lg border border-slate-200 bg-white shadow-sm", className)}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardHeader({ className, children }: PropsWithChildren<{ className?: string }>) {
  return <div className={cn("border-b border-slate-200 px-5 py-4", className)}>{children}</div>;
}

export function CardTitle({
  className,
  children,
  ...rest
}: PropsWithChildren<HTMLAttributes<HTMLHeadingElement>>) {
  return (
    <h3 className={cn("text-base font-semibold text-slate-900", className)} {...rest}>
      {children}
    </h3>
  );
}

export function CardBody({ className, children, id }: PropsWithChildren<{ className?: string; id?: string }>) {
  return <div id={id} className={cn("px-5 py-4", className)}>{children}</div>;
}
